import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import i18next from 'i18next';

import { useAuth } from '../../../contexts/AuthContext';

import './i18n';
import styles from './styles.module.scss';

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(false);
    setSubmitting(true);

    const ok = await login(username, password);

    if (ok) {
      navigate('/projects');
    } else {
      setError(true);
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <h1 className={styles.title}>{i18next.t('login:title')}</h1>

        {error && <p className={styles.error}>{i18next.t('login:error')}</p>}

        <div className={styles.field}>
          <label className={styles.label} htmlFor="login-username">
            {i18next.t('login:username')}
          </label>
          <input
            id="login-username"
            className={styles.input}
            type="text"
            autoComplete="username"
            value={username}
            onChange={event => setUsername(event.target.value)}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="login-password">
            {i18next.t('login:password')}
          </label>
          <input
            id="login-password"
            className={styles.input}
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </div>

        <button className={styles.submit} type="submit" disabled={submitting || !username || !password}>
          {submitting ? i18next.t('login:submitting') : i18next.t('login:submit')}
        </button>
      </form>
    </div>
  );
}

export default Login;
